import { ClientGate } from '@elements/client-gate'
import { withDateFormat } from '@utils/date-time'
import { nthNumber } from '@utils/strings'

export function ReservationConfirmationCopy({ reservationDate }: { reservationDate: string }) {
  return (
    <div className="space-y-3">
      <p>
        Thank you for submitting your reservation request for{' '}
        <ClientGate>
          {withDateFormat(reservationDate, 'cccc LLLL d')}
          {nthNumber(new Date(reservationDate).getHours())},{' '}
          {withDateFormat(reservationDate, 'yyyy')}.
        </ClientGate>
      </p>
      <p>
        Your information has been sent, and you should receive a response shortly. Please note that
        your booking is not complete until you receive a written confirmation.
      </p>
    </div>
  )
}
